export const BREADCRUMBS = [
    {
        titleKey: 'collections_perseus.collection_page.header.home',
        namedRoute: 'root',
    },
    {
        titleKey: 'collections_perseus.collection_page.header.my_lists',
        namedRoute: 'collections_lobby_my_lists',
    },
];
